import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import { Translate, ICrudGetAction } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { IRootState } from 'app/shared/reducers';
import { getEntity } from './job-order-owner.reducer';
import { IJobOrderOwner } from 'app/shared/model/job-order-owner.model';
import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';

export interface IJobOrderOwnerDetailProps extends StateProps, DispatchProps, RouteComponentProps<{ id: string }> {}

export const JobOrderOwnerDetail = (props: IJobOrderOwnerDetailProps) => {
  useEffect(() => {
    props.getEntity(props.match.params.id);
  }, []);

  const { jobOrderOwnerEntity } = props;
  return (
    <Row>
      <Col md="8">
        <h2>
          <Translate contentKey="ordersManagementApp.jobOrderOwner.detail.title">JobOrderOwner</Translate> [<b>{jobOrderOwnerEntity.id}</b>]
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="name">
              <Translate contentKey="ordersManagementApp.jobOrderOwner.name">Name</Translate>
            </span>
          </dt>
          <dd>{jobOrderOwnerEntity.name}</dd>
          <dt>
            <span id="surname">
              <Translate contentKey="ordersManagementApp.jobOrderOwner.surname">Surname</Translate>
            </span>
          </dt>
          <dd>{jobOrderOwnerEntity.surname}</dd>
          <dt>
            <Translate contentKey="ordersManagementApp.jobOrderOwner.user">User</Translate>
          </dt>
          <dd>{jobOrderOwnerEntity.user ? jobOrderOwnerEntity.user.id : ''}</dd>
          <dt>
            <Translate contentKey="ordersManagementApp.jobOrderOwner.businessUnit">Business Unit</Translate>
          </dt>
          <dd>{jobOrderOwnerEntity.businessUnit ? jobOrderOwnerEntity.businessUnit.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/job-order-owner" replace color="info">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/job-order-owner/${jobOrderOwnerEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

const mapStateToProps = ({ jobOrderOwner }: IRootState) => ({
  jobOrderOwnerEntity: jobOrderOwner.entity
});

const mapDispatchToProps = { getEntity };

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(mapStateToProps, mapDispatchToProps)(JobOrderOwnerDetail);
